import { useTranslation } from 'react-i18next';

// eslint-disable-next-line import/no-cycle
import { PlotListDesktop } from '@/pages/shared/plots/components/PlotListDesktop';
import {
  useRankedByResilienceCustomCells,
  useRankedByRiskCustomCells,
} from '@/pages/shared/plots/hooks/useGetCustomCells';

import { Card } from '../widgets/o/Card/Card';

export const RankedByRiskPlotGroupList = () => {
  const { t } = useTranslation();

  const rankedByRiskSortFilters = {
    default_sort_field: 'nature_risk_desc',
  };
  const rankedByRiskList = useRankedByRiskCustomCells();

  const defaultListConfig = {
    showActions: false,
    showSort: false,
    pageSize: 5,
    showPagination: false,
  };

  return (
    <Card
      header={t('global.widget.rankingTables.rankedByRisk')}
      headerTooltip={t('global.widget.rankingTables.rankedByRiskTooltip')}
      styles={{
        root: 'border-none w-full flex-1',
        header: 'border-none typography-h3 px-0 py-2',
        body: 'border-none rounded-2xl flex-1 flex flex-col gap-4 py-0 px-0',
      }}
    >
      <PlotListDesktop customColumns={rankedByRiskList} plotFilters={rankedByRiskSortFilters} {...defaultListConfig} />
    </Card>
  );
};

export const RankedByResiliencePlotGroupList = () => {
  const { t } = useTranslation();

  const rankedByResilienceSortFilters = {
    default_sort_field: 'resilience_desc',
  };

  const rankedByResilienceList = useRankedByResilienceCustomCells();

  const defaultListConfig = {
    showActions: false,
    showSort: false,
    pageSize: 5,
    showPagination: false,
  };
  return (
    <Card
      header={t('global.widget.rankingTables.rankedByResilience')}
      headerTooltip={t('global.widget.rankingTables.rankedByResilienceTooltip')}
      styles={{
        root: 'border-none w-full flex-1',
        header: 'border-none typography-h3 px-0 py-2',
        body: 'border-none rounded-2xl flex-1 flex flex-col gap-4 py-0 px-0',
      }}
    >
      <PlotListDesktop
        customColumns={rankedByResilienceList}
        plotFilters={rankedByResilienceSortFilters}
        {...defaultListConfig}
      />
    </Card>
  );
};
